import React from 'react';
import Modal from './ModalConversion';

const CONVERSION_STATUS = { '0': 'Nuevo', '1': 'Terminado', '2': 'En proceso' };
const ISBN_STATUS = { '0': 'Registrado', '1': 'En trámite', '2': 'Asignado' };
const COVER_STATUS = {
    '0': 'Pendiente información',
    '1': 'Solicitud',
    '2': 'Pendiente de aprobación',
    '3': 'Solicitud de cambio',
    '4': 'Aprobado',
};
const SERVICE_LABELS = { cover: 'Portada', isbn: 'ISBN', conversion: 'Conversión' };

const baseName = (path) => (path ? String(path).split('/').pop() : '—');

const DetailItem = ({ label, full, children }) => (
    <div className={full ? 'col-12' : 'col-md-6'}>
        <div className="text-white-50 small text-uppercase fw-bold mb-1">{label}</div>
        <div className="text-white text-break">{children ?? '—'}</div>
    </div>
);

export function ConversionDetailModal({ isOpen, onClose, project }) {
    if (!project) return null;

    const isbn = project.isbn_info || {};
    const cover = project.cover_info || {};
    const services = Array.isArray(project.services) ? project.services : [];
    const hasIsbn = services.includes('isbn') || !!project.isbn_info;
    const hasCover = services.includes('cover') || !!project.cover_info;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="p-2">
                <h3 className="mb-1 text-white">Detalle de la conversión</h3>
                <p className="text-white-50 mb-4">
                    {project.account}-C-{project.ink_id} · {project.title}
                </p>

                <section className="mb-3 p-3 bg-dark rounded border border-secondary">
                    <h6 className="text-uppercase text-white-50 small fw-bold mb-3">Datos generales</h6>
                    <div className="row g-3">
                        <DetailItem label="Cuenta">{project.account}</DetailItem>
                        <DetailItem label="Ink ID">{project.ink_id}</DetailItem>
                        <DetailItem label="Título" full>{project.title}</DetailItem>
                        <DetailItem label="Estado de conversión">
                            {CONVERSION_STATUS[String(project.status)] || 'Pendiente'}
                        </DetailItem>
                        <DetailItem label="Fecha de creación">{project.created}</DetailItem>
                        <DetailItem label="Páginas">{project.pages_count}</DetailItem>
                        <DetailItem label="Maquetación">
                            {project.epub_layout === 'reflowable'
                                ? 'Reflowable'
                                : (project.epub_layout || null)}
                        </DetailItem>
                        <DetailItem label="Pagado">{project.paid === 1 ? 'Sí' : 'No'}</DetailItem>
                        <DetailItem label="Accesible (EPUB)">
                            {project.epub_accessible ? 'Sí' : 'No'}
                        </DetailItem>
                        <DetailItem label="Proyecto de distribución">
                            {project.distribution
                                ? `Sí · ${project.account}-D-${project.distribution}`
                                : 'No asociado'}
                        </DetailItem>
                        <DetailItem label="Archivo EPUB">{baseName(project.epub)}</DetailItem>
                        <DetailItem label="Fuente">
                            {project.sources
                                ? <a href={project.sources} target="_blank" rel="noreferrer" className="link-info">Abrir documento</a>
                                : null}
                        </DetailItem>
                    </div>
                </section>

                <section className="mb-3 p-3 bg-dark rounded border border-secondary">
                    <h6 className="text-uppercase text-white-50 small fw-bold mb-3">Servicios</h6>
                    {services.length > 0 ? (
                        <div className="d-flex flex-wrap gap-2">
                            {services.map((service) => (
                                <span key={service} className="badge bg-secondary">
                                    {SERVICE_LABELS[service] || service}
                                </span>
                            ))}
                        </div>
                    ) : (
                        <span className="text-white-50">Sin servicios</span>
                    )}
                </section>

                {hasIsbn && (
                    <section className="mb-3 p-3 bg-dark rounded border border-secondary">
                        <h6 className="text-uppercase text-white-50 small fw-bold mb-3">ISBN</h6>
                        <div className="row g-3">
                            <DetailItem label="Estado">
                                {ISBN_STATUS[String(isbn.status ?? '0')] || 'Registrado'}
                            </DetailItem>
                            <DetailItem label="Número de ISBN">{isbn.isbn || 'Sin asignar'}</DetailItem>
                            <DetailItem label="Observaciones" full>{isbn.observations}</DetailItem>
                            <DetailItem label="Archivo del cliente">
                                {isbn.user_file
                                    ? <a href={isbn.user_file} target="_blank" rel="noreferrer" className="link-info">Abrir archivo</a>
                                    : null}
                            </DetailItem>
                        </div>
                    </section>
                )}

                {hasCover && (
                    <section className="mb-3 p-3 bg-dark rounded border border-secondary">
                        <h6 className="text-uppercase text-white-50 small fw-bold mb-3">Portada</h6>
                        <div className="row g-3">
                            <DetailItem label="Estado">
                                {COVER_STATUS[String(cover.status ?? '0')] || 'Pendiente información'}
                            </DetailItem>
                            <DetailItem label="¿Tiene derechos?">{cover.has_rights ? 'Sí' : 'No'}</DetailItem>
                            <DetailItem label="Revisiones">
                                {(cover.revisions_used || 0)} / {(cover.max_revisions || 0)}
                            </DetailItem>
                            <DetailItem label="Descripción" full>{cover.description}</DetailItem>
                            <DetailItem label="Observaciones" full>{cover.observations}</DetailItem>
                            <DetailItem label="Archivo del cliente">
                                {cover.user_file
                                    ? <a href={cover.user_file} target="_blank" rel="noreferrer" className="link-info">Abrir archivo</a>
                                    : null}
                            </DetailItem>
                            <DetailItem label="Archivo admin">
                                {cover.admin_file
                                    ? <a href={cover.admin_file} target="_blank" rel="noreferrer" className="link-info">Abrir archivo</a>
                                    : null}
                            </DetailItem>
                        </div>
                    </section>
                )}

                <div className="d-flex justify-content-end mt-4 pt-3 border-top border-secondary">
                    <button type="button" className="btn btn-primary px-4" onClick={onClose}>Cerrar</button>
                </div>
            </div>
        </Modal>
    );
}

export default ConversionDetailModal;
